package com.essntl.features.proposal.ui.addeditproposal

import androidx.compose.ui.platform.ClipboardManager
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.file.domain.model.FileModel
import com.essntl.features.price.domain.model.proposalserviceprice.ProposalServicePriceModel
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.proposal.domain.model.ProposalServiceModel
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.features.task.domain.model.TaskModel
import com.mohamedrejeb.calf.core.PlatformContext

sealed interface AddEditProposalEvent {
    data object GetProposal : AddEditProposalEvent

    data class UpdateProposalServicePrices(val prices: List<ProposalServicePriceModel>) : AddEditProposalEvent

    data class EditTaskStatus(
        val taskId: String,
        val status: TaskModel.Status,
    ) : AddEditProposalEvent

    data class DeleteTask(
        val task: TaskModel,
    ) : AddEditProposalEvent

    data class UpdateProposalDates(
        val proposalId: String,
        val startDate: String,
        val context: PlatformContext,
    ) : AddEditProposalEvent

    data class UpdateProposalFields(val proposal: ProposalModel) : AddEditProposalEvent

    data class UpdateProposalTravelAgent(val travelAgentId: String) : AddEditProposalEvent

    data class AddProposal(
        val context: PlatformContext,
    ) : AddEditProposalEvent

    data class PublishProposal(
        val description: String,
        val clipboardManager: ClipboardManager,
    ) : AddEditProposalEvent

    data object ClearPublish : AddEditProposalEvent

    data class AddClient(val client: ClientModel) : AddEditProposalEvent
    data class EditClient(val client: ClientModel) : AddEditProposalEvent
    data class DeleteClient(val client: ClientModel) : AddEditProposalEvent
    data class EditProposal(
        val context: PlatformContext,
    ) : AddEditProposalEvent

    data class AddProposalService(
        val service: ServiceModel,
        val proposalService: ProposalServiceModel,
        val date: String,
        val index: Int,
        val dropped: Boolean,
        val context: PlatformContext,
    ) : AddEditProposalEvent

    data class DeleteProposalService(val date: String, val index: Int) : AddEditProposalEvent

    data class MarkProposalServiceAsPaid(val proposalService: ProposalServiceModel) : AddEditProposalEvent
    data class HideServiceOnProposal(val proposalService: ProposalServiceModel) : AddEditProposalEvent
    data object ClearSuccessState : AddEditProposalEvent
    data class SelectProposalServiceDate(val date: String) : AddEditProposalEvent
    data class AddProposalServiceToGroup(val id: String) : AddEditProposalEvent
    data class ProposalServiceGrouped(val ids: Set<String>, val date: String, val isCtrlPressed: Boolean) :
        AddEditProposalEvent

    data class UpdateSelectedProposalService(val proposalService: ProposalServiceModel?) : AddEditProposalEvent
    data class UnselectProposalService(val proposalService: ProposalServiceModel?) : AddEditProposalEvent
    data class UpdateProposalService(val proposalService: ProposalServiceModel) : AddEditProposalEvent
    data class UpdateAlertSaveProposalDialog(val isVisible: Boolean) : AddEditProposalEvent

    /**
     * Cover Image Events
     */
    data class AddCoverImage(val file: FileModel) : AddEditProposalEvent
    data object DeleteCoverImage : AddEditProposalEvent
}